import React, {useEffect, useState, useCallback, memo} from "react";
import Chart from "react-apexcharts";

const optionTitle = {
  align: 'center',
  margin: 0,
  offsetX: 0,
  offsetY: 0,
  floating: false,
  style: {
    fontSize:  '14px',
    fontWeight:  'normal',
  },
}
const ChartDonut = ({count=0, data}) => {
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({
      chart: {
        type: "donut"
      },
      dataLabels: {
          enabled: true
      },
      // labels: ["minute 0-10", "minute 20-30"],
      plotOptions: {
        pie: {
          donut: {
            size: "50%"
          }
        }
      },
      // title: {
      //   text: "",
      //   align: 'center',
      //   margin: 0,
      //   offsetX: 0,
      //   offsetY: 0,
      //   floating: false,
      //   style: {
      //     fontSize:  '14px',
      //     fontWeight:  'normal',
      //   },
      // }
    });
  
  useEffect(() => {
    if (data?.length !== 0 && count !== 0){
      chartdata(data)
    } else {
      setSeries({})
      setOptions(()=>({
        ...options,
        labels: [],
      }))
    }
  }, [data])
  
  const chartdata = useCallback(async(value) => {    
    const seriesData = []
    const labelsData = []
    Object.values(value).map((item)=>{
      if (item?.count !== undefined){
        seriesData?.push(item?.count)
      }
      if (item?.title !== undefined || item?.unit !== undefined){
        labelsData?.push(`${item?.title} ${item?.unit || ""}`)
      }
    })
    setSeries(seriesData)
    setOptions(()=>({
      ...options,
      labels: labelsData,
      title: {
        ...optionTitle,
        text: (`Total count: ${count}` || ""),
      }
    }))
  }, [])

  return (<Chart options={options} series={series} type="donut" />);
};
export default memo(ChartDonut);
